import { render } from "./TurnstileChallenge.vue?vue&type=template&id=2a014961&scoped=true"
import script from "./TurnstileChallenge.vue?vue&type=script&lang=ts"
export * from "./TurnstileChallenge.vue?vue&type=script&lang=ts"

import "./TurnstileChallenge.vue?vue&type=style&index=0&id=2a014961&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2a014961"

export default script